/**
 * Activity Repository Hook
 *
 * Provides access to the activity repository from the context.
 */

import { useRepositoryContext } from '../repositories';
import type { IActivityRepository } from '../repositories/interfaces/IActivityRepository';

/**
 * Hook to access the activity repository
 * Must be used within a RepositoryProvider
 */
export function useActivityRepository(): IActivityRepository {
  const { activities } = useRepositoryContext();
  return activities;
}
